import {
    useEffect
} from 'react';
import {
    useNavigate, useParams
} from 'react-router-dom';

/**
 * Legacy `/library/opcode/:opcodeId` → Library inline editor (`?tab=opcodes&edit=:id`).
 */
export default function LibraryOpcodeRedirect() {
    const {
        oragID, subOragID, opcodeId
    } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!oragID || !subOragID || !opcodeId) return;
        navigate(
            `/organizations/${oragID}/sub/${subOragID}/de-studio/library?tab=opcodes&edit=${opcodeId}`,
            { replace: true }
        );
    }, [oragID, subOragID, opcodeId, navigate]);

    return null;
}
